import { Button, Modal, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import OtpInput from "react18-input-otp";
import { CloseIcon } from "../../../../Assets/icons";
import { translation } from "../../../../i18n/translationConstant";
import { UserRespose } from "../../../../redux/Reducer/userReducer";
import "./index.css";
import OTPInputModalFooter from "./OTPInputModalFooter";

interface IModalComponentProps extends React.PropsWithChildren {
  isOpen: boolean;
  onOtpSubmit: (otp: string) => void;
  onCancel: () => void;
  okText: string;
  numInputs?: number;
  title: string;
  onResend?: () => void;
  isOtpInputVisible?: boolean;
  isPinModal?: boolean;
  user: UserRespose;
  mobileNumber?: string;
}

const OTPInputComponent: React.FC<IModalComponentProps> = ({
  isOpen,
  okText,
  numInputs,
  onOtpSubmit,
  onCancel,
  children,
  title,
  onResend,
  isOtpInputVisible,
  isPinModal,
  user,
  mobileNumber,
}) => {
  const otpResendDuration = 60;
  const [OTP, setOTP] = useState("");
  const [counter, setCounter] = useState(otpResendDuration);
  const timer = useRef<any>();
  const { t } = useTranslation();

  useEffect(() => {
    if (!isOpen) {
      setOTP("");
      setCounter(0);
    } else {
      setCounter(otpResendDuration);
    }
  }, [isOpen]);

  const changeInput = (otp: string) => {
    setOTP(otp);
  };

  useEffect(() => {
    if (counter <= 0) {
      clearTimeout(timer.current);
      return;
    }
    timer.current = setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const maskMobileNumber = (number?: string) => {
    if (!number) {
      return "";
    }

    return `XXXXXX${number.slice(-4)}`;
  };

  const displayedMobileNumber = maskMobileNumber(
    mobileNumber ? mobileNumber : user.mobileNumber
  );

  const resendOTP = () => {
    setOTP("");
    setCounter(otpResendDuration);
    onResend && onResend();
  };

  return (
    <Modal
      className="otpModal"
      visible={isOpen}
      okText={okText}
      cancelButtonProps={{ hidden: true }}
      destroyOnClose={true}
      okButtonProps={{ id: "submitButton" }}
      footer={[
        // tslint:disable-next-line: jsx-key
        <OTPInputModalFooter
          // tslint:disable-next-line: jsx-no-lambda
          onOtpModalFooterSubmit={() => onOtpSubmit(OTP)}
          isResendActive={true}
          buttonLabel={okText}
          counter={counter}
          onResend={resendOTP}
        />,
      ]}
      onCancel={onCancel}
      closeIcon={<CloseIcon />}
    >
      {/* =====================================================
          OTP ICON
          ===================================================== */}

      <div className="otpIconWrapper">
        <div className="otpIcon">
          <span className="otpIconLine" />
          <span className="otpIconLine otpIconLine2" />
          <span className="otpIconFold otpIconFoldLeft" />
          <span className="otpIconFold otpIconFoldRight" />
        </div>
      </div>

      {/* =====================================================
          TITLE
          ===================================================== */}

      <Typography.Text className="typoOTP">
        {title ? title : t(translation.lblEnterOTP)}
      </Typography.Text>

      {/* =====================================================
          OTP SENT MESSAGE
          ===================================================== */}

      <Typography.Text className="otpSentTypo">
        {isPinModal ? (
          t(translation.lblEnterPinModel)
        ) : (
          <>
            {t(translation.lblOtpSent)}{" "}
            <Typography.Text className="otpNumber">
               {displayedMobileNumber}
            </Typography.Text>
          </>
        )}
      </Typography.Text>

      {!isPinModal && (
        <Typography.Text className="otpInstruction">
          Enter the code below to continue securely.
        </Typography.Text>
      )}

      {/* =====================================================
          EXISTING OTP LOGIC - UNCHANGED
          ===================================================== */}

      {isOtpInputVisible ? (
        children
      ) : (
        <div className="otpModalWidth">
          <OtpInput
            value={OTP}
            onChange={changeInput}
            containerStyle={"containerClass"}
            numInputs={numInputs ? numInputs : 4}
            shouldAutoFocus={true}
            inputStyle={"inputStyle"}
            isInputSecure={true}
            inputProps={{
              onKeyDown: (e) => {
                if (e.key === "Enter") {
                  onOtpSubmit(OTP);
                }

                if (e.key === "Backspace") {
                  e.preventDefault();
                  setOTP((prev) => prev.slice(0, prev.length - 1));
                }
              },
            }}
          />

          {/* =================================================
              COUNTER + RESEND
              ================================================= */}

          <div className="counterRoot">
            <Typography.Text className="counter">
              {counter !== 0 ? `${counter} sec left` : ""}
            </Typography.Text>

            <Button
              disabled={counter !== 0}
              id="resendButton"
              type="text"
              onClick={resendOTP}
            >
              Resend OTP
            </Button>
          </div>
        </div>
      )}

      {/* =====================================================
          SECURITY MESSAGE
          ===================================================== */}

      <div className="otpSecurity">
        <span className="otpSecurityIcon">✓</span>

        <Typography.Text className="otpSecurityText">
          Your information is encrypted and secure
        </Typography.Text>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(OTPInputComponent);